import(/* webpackMode: "eager" */ "/codebuild/output/src3110158394/src/autofoc.us/src/app/forgot-password/page.js");
